import { api } from './api';

export const relatoriosSaidaService = {
  imprimirSaidasPorPraca: async (dataRetornoPrevista: string, idPraca: number): Promise<Blob> => {
    const response = await api.get<Blob>(`/api/Saida/GetSaidasPorPracaXlsx?dataRetornoPrevista=${dataRetornoPrevista}&idPraca=${idPraca}`);
    return response.data;
  },

  imprimirVendasPorReferenciaPeriodo: async (data: {
    dataInicioCobranca: string;
    dataFimCobranca: string;
    idPraca: number;
    idsProdutos: number[];
  }): Promise<Blob> => {
    const response = await api.post<Blob>('/api/Saida/GetVendasPorReferenciaPeriodoXlsx', data);
    return response.data;
  },

  imprimirVendasPorPeriodoPorLinha: async (data: {
    dataInicioCobranca: string;
    dataFimCobranca: string;
  }): Promise<Blob> => {
    const response = await api.post<Blob>('/api/Saida/GetVendasPorPeriodoPorLinhaXlsx', data);
    return response.data;
  },

  imprimirCobrancaPorPraca: async (data: {
    dataInicioCobranca: string;
    dataFimCobranca: string;
    idPraca: number;
  }): Promise<Blob> => {
    const response = await api.post<Blob>('/api/Saida/GetCobrancaPorPracaXlsx', data);
    return response.data;
  },
};
